import { useTranslation } from "react-i18next";
import U2000SaveBtn from "../../buttons/U2000SaveBtn";
import U2000CancelBtn from "../../buttons/U2000CancelBtn";
import type { U2000FormStateHandlers } from "../../../reducer/formReducer/U2000FormStateHandlers";

type U2000SaveCancelProps<T extends Record<string, any> = Record<string, any>> = {
  formStateHandlers: U2000FormStateHandlers<T>;
};

const U2000SaveCancel = <T extends Record<string, any> = Record<string, any>>({ formStateHandlers }: U2000SaveCancelProps<T>) => {
  const { t } = useTranslation();

  const handleSubmit = () => {
    formStateHandlers.saveData();
  };

  const handleMouseDown = () => {
    formStateHandlers.cancelData();
  };

  return (
    <>
      <U2000SaveBtn label={t("btnSave")} handleClick={handleSubmit} disabled={!formStateHandlers.isValid()} />
      <U2000CancelBtn label={t("btnCancel")} handleMouseDown={handleMouseDown} />
    </>
  );
};

export default U2000SaveCancel;
